

namespace Gordic.Epk.WebControls {

    /** 
     *  akce EPK05 - pro použití v menu 
     */
    export class GEpkActionsService {

        /** třída společných akcí v epk */
        private epkAction: GContent;

        public getEpkActionContent() {
            if (this.epkAction == null) {
                this.epkAction = new GContent("Gordic.Epk.WebControls.GEpkActionsService");
            }
        }

        /** název async. úlohy */
        private epkVisualSignAsyncTaskName = "Gordic.Wfl.Server.GEpkVisualSignAsyncTask";

        private cleanReturnNotificationAsyncTask(className: string) {
            var tasks = Gordic.Async.GTaskManager.findByClass(className);
            for (var index = 0; index < tasks.length; index++) {
                var task = tasks[index];
                task.cancel(true);
                console.log("AsyncTaskCancel: " + task.className);
            }
        }

        private 

        /** aktualizace badge ručních vizuálních podpisů */
        public updateBadgeHandVisualSign(_cnt: any, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null, multi: boolean) {

            const that = this;
            const cnt: GContentType<GEpkDbParamsNew> = _cnt;
            const name = this.epkVisualSignAsyncTaskName;

            Gordic.Async.GTaskManager.off("init");
            Gordic.Async.GTaskManager.off("done");


            if (multi === true || row == null || row.ixp == null) {
                this.updateBadgeUmisteniPodpisu(cnt, false);
                return;
            }

            Gordic.Async.GTaskManager.getInitPromise().done((a) => {

                this.cleanReturnNotificationAsyncTask(name);

                Gordic.Async.GTaskManager.on("init", name, (o: any) => {
                    console.log("AsyncTaskInit: ", name);
                });

                var data = { Ixp: row.ixp, Ixb: row.ixb, SerCislo: row.ser_cislo };

                // odložený start
                Gordic.Async.GTaskManager.delayedStart(name, data, { clearOnFinish: true, autoClean: true });
           
                Gordic.Async.GTaskManager.on("done", name, function (o: any) {
                    console.log("AsyncTaskDone: ", o);
                    /** nastavení příznaku ručního viz. podpisu */
                    var handVisualSign = false;
                    if (o != null && o.result != null && o.result.VisualSignCount != null && o.result.VisualSignCount > 0)  // kontrola na neexistenci property
                        handVisualSign = true;
                    that.updateBadgeUmisteniPodpisu(cnt, handVisualSign);

                    this.clean(); //uklizeni vysledku ulohy
                });

            });

        }



        /**
         * aktualizace vizuálního podpisu v menubaru přímo v náhledu na soubor
         */
        public updateBadgeVisualPlacement(cnt: any, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto, ixb: string) {

            var dfd = $.Deferred();

            //Gordic.Async.GTaskManager.cancel(this.epkVisualSignAsyncTaskName);
            //var asyncTask = Gordic.Async.GTaskManager.start<Gordic.Async.IGTaskProgress, any>(this.epkVisualSignAsyncTaskName, { Ixp: row.ixp, Ixb: ixb, SerCislo: row.ser_cislo });

            //asyncTask
            //    .getPromise()
            //    .then((output) => {
            //        var handVisualSign = false; // příznak ručního viz. podpisu
            //        if (output != null && output.result != null && output.result.VisualSignCount != null && output.result.VisualSignCount > 0)  // kontrola na neexistenci property
            //            handVisualSign = true;

            //        if (cnt.closed === true) {
            //            Gordic.Async.GTaskManager.cancel(asyncTask);
            //            dfd.reject();
            //        }
            //        else {
            //            Gordic.Async.GTaskManager.clean(asyncTask);
            //            dfd.resolve(handVisualSign);
            //        }
            //    })

            const name = this.epkVisualSignAsyncTaskName;

            Gordic.Async.GTaskManager.off("init");
            Gordic.Async.GTaskManager.off("done");

            Gordic.Async.GTaskManager.getInitPromise().done((a) => {

                this.cleanReturnNotificationAsyncTask(name);

                Gordic.Async.GTaskManager.on("init", name, (o: any) => {
                    console.log("AsyncTaskInit: ", name);
                });

                var data = { Ixp: row.ixp, Ixb: ixb, SerCislo: row.ser_cislo };

                // odložený start
                Gordic.Async.GTaskManager.delayedStart(name, data, { clearOnFinish: true, autoClean: true });

                Gordic.Async.GTaskManager.on("done", name, function (o: any) {

                    console.log("AsyncTaskDone: ", o);

                    /** nastavení příznaku ručního viz. podpisu */
                    var handVisualSign = false;
                    if (o != null && o.result != null && o.result.VisualSignCount != null && o.result.VisualSignCount > 0)  // kontrola na neexistenci property
                        handVisualSign = true;

                    if (cnt.closed === true) {
                        dfd.reject();
                    }
                    else {
                        dfd.resolve(handVisualSign);
                    }

                    this.clean(); //uklizeni vysledku ulohy
                });

            });


            return dfd.promise();
        }

        /**
         * aktualizace badge na akci umístění podpisu
         * @param handle
         * @param cnt
         */
        public updateBadgeUmisteniPodpisu(cnt: GContentType<GEpkDbParamsNew>,handle: boolean) {
            var id = "idHandVisualSignPositionBadge";
            var value = "jres:32000595"; //RC 32000595 : Ručně
            var tooltip = "jres:32000596"; //RC 32000596 : Obsahuje ručně zadaný vizuální podpis

            if (cnt.badgeUmisteniPodpisu == null) {
                cnt.badgeUmisteniPodpisu = new GObservableObject({
                    id: id,
                    value: handle === true ? value : "",
                    tooltip: handle === true ? tooltip : ""
                })
            }
            else {
                cnt.badgeUmisteniPodpisu.update({
                    id: id,
                    value: handle === true ? value : "",
                    tooltip: handle === true ? tooltip : ""
                });
            }
        }

        /** příznak otevření komponenty umístění vizuálního podpisu */
        private signatureLocationComponentIsOpen = false;

        public getParamActionSignatureLocation(_cnt: any, nameAction: string, detail?: boolean) {
            var cnt: GContentType<GEpkDbParamsNew> = _cnt;
            // Pozice obrázku doplněného po přidání el. podpisu (např. do PDF)
            // Pokud není 0, zapne se umísťovací komponenta 
            // Vizuální umístění podpisu
            // 1- Ano, 2- Ano, včetně příloh
            if (cnt.EpkParams.gin_pdf_pictpos !== 0 && cnt.EpkParams.epk_povumipod !== 0)
                this.updateBadgeUmisteniPodpisu(cnt, false);

            cnt.hideFlash("idPositionSign");
            var param: MenuParams = {
                visiblePriority: 15,
                favorite: false,
                align: "opposite",
                badge: cnt.badgeUmisteniPodpisu,
                action: cnt.actions.add(new GAction({
                    enabled: true,
                    name: nameAction,
                    icon: "fa-map-marker",
                    caption: "jres:32000551",	                //RC 32000551 : Umístění podpisu
                    run: () => {

                        var flash = "IdVisualPositionFlash";
                        cnt.hideFlash(flash);

                        if (cnt.closed === true)
                            return;

                        if (detail === true) {
                            var rowDetail = cnt.row;
                            if (rowDetail != null && rowDetail.ixp != null) {
                                this.addSignatureLocation(cnt, rowDetail.ixp, rowDetail.ser_cislo, rowDetail.ixs_dpo, rowDetail.ixb);
                                return;
                            }
                        }
                        else {  // grid

                            var selection: Gordic.Wfl.Interface.GPodpisovaKnihaDto[] = cnt.grid.ggrid("getSelection");

                            if (selection.length > 1) {
                                // multi výběr
                                cnt.showFlash("jres:32000845", "warning", flash); //RC 32000845 : Nelze vybrat umístění podpisu při výběru více řádků.
                                return;
                            }
                            else {
                                if (selection.length === 1) {
                                    var rowGrid = selection[0] as Gordic.Wfl.Interface.GPodpisovaKnihaDto;
                                    if (rowGrid != null && rowGrid.ixp != null) {
                                        this.addSignatureLocation(cnt, rowGrid.ixp, rowGrid.ser_cislo, rowGrid.ixs_dpo, rowGrid.ixb);
                                        return;
                                    }
                                }
                            }

                        }

                        cnt.showFlash("jres:32000846", "warning", flash); //RC 32000846 : Umístění vizuálního podpisu není k dispozici.
                        return;

                    }
                }))
            }
            return param;
        }

        /**
         * metoda pro umístění souboru u náhledovačky na detailu žádosti
         * @param cnt
         * @param row
         * @param ixb
         */
        public addSignaturePlacement(cnt, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto, ixb: string, isFavorite: boolean): JQuery.Promise<boolean> {
            var dfd = $.Deferred();
            if (this.signatureLocationComponentIsOpen === false) {
                this.signatureLocationComponentIsOpen = true;
                Gordic.Wfl.AttachmentUtils.addSignatureLocation({
                    cnt: cnt,
                    ixp: row.ixp,
                    ix: Wfl.Interface.GSignaturePositionBindingAllowedIx.Soubor,
                    showFlash: true,
                    //ixsSpd: ixs_spd,
                    serCisloEpk: row.ser_cislo!,
                    ixsDpo: row.ixs_dpo,
                    ixb: ixb  // thazmuka (30.3.2022)
                })
                .then(() => {
                    this.signatureLocationComponentIsOpen = false;

                    if(isFavorite === true)                             // pouze pro obraz - updatuje badge obrazu v menu
                        this.updateBadgeUmisteniPodpisu(cnt, true);
                    dfd.resolve(true);
                })
                .fail(() => {
                    dfd.resolve(false);
                })
            }
            return dfd.promise();
        }

        private addSignatureLocation(cnt, ixp, serCisloEpk, ixsDpo, ixb) {

            if (this.signatureLocationComponentIsOpen === false) {
                this.signatureLocationComponentIsOpen = true;

                Gordic.Wfl.AttachmentUtils.addSignatureLocation({
                    cnt: cnt,
                    ixp: ixp,
                    ix: Wfl.Interface.GSignaturePositionBindingAllowedIx.Soubor,
                    showFlash: true,
                    //ixsSpd: ixs_spd,
                    serCisloEpk: serCisloEpk,
                    ixsDpo: ixsDpo,
                    ixb: ixb  // thazmuka (30.3.2022)
                })
                    .then((output: Wfl.AttachmentUtils.ISignatureLocation) => {
                        // thazmuka (28.03.2021) - ošetření vložení vizuál. podpisu
                        //var state = output.type !== Wfl.AttachmentUtils.SignatureLocationEnum.fail
                        this.updateBadgeUmisteniPodpisu(cnt, true);
                    })
                    .always(() => {
                        // došlo k zavření komponenty umístění vizuálního podpisu;
                        this.signatureLocationComponentIsOpen = false;
                    })
            }

        }

    }

}